var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3244 18.1758L28 19.5141L25.3244 20.8565L23.9872 23.5272L22.6499 20.8565L19.9743 19.5141L22.6499 18.1758L23.9872 15.5011L25.3244 18.1758ZM10.6114 8.85041L7.93583 7.51306L10.6114 6.17571L11.9487 3.5L13.2859 6.17571L15.9615 7.51306L13.2859 8.85041L11.9487 11.5261L10.6114 8.85041ZM23.318 8.18224L20.9775 7.01143L23.318 5.84062L24.4888 3.5L25.6595 5.84062L28 7.01143L25.6595 8.18224L24.4888 10.5229L23.318 8.18224Z",
    fill: "url(#paint0_linear_6951_14107)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00046 24.4794C3.98663 23.6829 4.28255 22.912 4.82587 22.3294L13.0685 14.085L17.4511 18.3947L9.16976 26.6746C8.58705 27.2178 7.81622 27.5135 7.01972 27.4995C6.22323 27.4855 5.46328 27.1628 4.90005 26.5994C4.33682 26.036 4.0143 25.2759 4.00046 24.4794Z",
    fill: "url(#paint1_linear_6951_14107)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1133 10.1676L21.3319 12.3863C21.9196 12.974 21.9195 13.927 21.3318 14.5147L18.602 17.2439L14.2231 12.9303L16.9851 10.1677C17.5727 9.5799 18.5256 9.57986 19.1133 10.1676Z",
    fill: "url(#paint2_linear_6951_14107)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6951_14107",
    x1: 23.7851,
    y1: 5.22053,
    x2: 0.909786,
    y2: 25.9915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.107101,
    stopColor: "#FFD480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378303,
    stopColor: "#F240A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731038,
    stopColor: "#1976D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6951_14107",
    x1: 23.7851,
    y1: 5.22053,
    x2: 0.909786,
    y2: 25.9915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.107101,
    stopColor: "#FFD480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378303,
    stopColor: "#F240A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731038,
    stopColor: "#1976D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6951_14107",
    x1: 23.7851,
    y1: 5.22053,
    x2: 0.909786,
    y2: 25.9915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.107101,
    stopColor: "#FFD480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378303,
    stopColor: "#F240A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731038,
    stopColor: "#1976D2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagic);
export default __webpack_public_path__ + "static/media/magic.7501379d452c8cd0bd3512e0e03de832.svg";
export { ForwardRef as ReactComponent };